import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  root: {
    width: 188,
  },
  rootMobile: {
    width: '100%',
  },
  mobileAction: {
    width: '100%',
  },
  container: {
    padding: '1px',
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #E4E4F2',
    cursor: 'pointer',
  },

  textFooter: {
    color: '#B0B5FF',
    fontFamily: 'Open Sans',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'none',
  },
  btnFull: {
    borderRadius: 5,
    color: '#000A8C',
    width: '100%',
    minHeight: 44,
    backgroundColor: '#fff',
    boxShadow: 'none',
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '14px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none',
    },
  },
  btnOutFilled: {
    borderRadius: 5,
    color: '#fff',
    width: '100%',
    minHeight: 44,
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    boxShadow: 'none',
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '14px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid #fff',
      boxShadow: 'none',
    },
  },
  btnFullMobile: {
    borderRadius: 5,
    color: '#000A8C',
    width: '100%',
    height: 38,
    minHeight: 38,
    padding: '0 25px',
    backgroundColor: '#fff',
    boxShadow: 'none',
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '14px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none',
    },
  },
  btnOutFilledMobile: {
    borderRadius: 5,
    color: '#fff',
    width: '100%',
    height: 38,
    minHeight: 38,
    padding: '0 25px',
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    boxShadow: 'none',
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '14px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid #fff',
      boxShadow: 'none',
    },
  },
  title: {
    color: '#000A8C',
    textAlign: 'center',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    textTransform: 'none',
    lineHeight: 1,
    margin: '8px 8px 12px',
    minHeight: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: 10,
      marginTop: 12,
    },
  },
  titleStatus: {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontStyle: 'italic',
    fontWeight: 600,
    lineHeight: '14px',
    margin: '10px 0px',
    textTransform: 'none',
  },
  containerCover: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 188,
    height: 267,
    minHeight: 267,
    background: '#FFF',
    borderRadius: 5,
    borderLeft: '5px solid #757788',
    padding: '6px 10px 12px',
    boxSizing: 'border-box',
  },
  containerCover2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: 231,
    minHeight: 231,
    background: '#FFF',
    borderRadius: 5,
    borderLeft: '5px solid #757788',
    padding: '6px 10px 12px',
    boxSizing: 'border-box',
  },
  containerCover2Game: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: 267,
    minHeight: 267,
    background: '#FFF',
    borderRadius: 5,
    borderLeft: '5px solid #757788',
    padding: '6px 10px 12px',
    boxSizing: 'border-box',
  },
  content2: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
  },
  containerElement: {
    width: '100%',
    height: 205,
    borderRadius: 5,
    overflow: 'hidden',
  },
  containerElement2: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    borderRadius: 5,
    overflow: 'hidden',
  },
  separator: {
    width: 55,
    height: 1,
    background: '#B0B5FF',
    opacity: 0.4,
    margin: '5px 0px',
  },
  spanText: {
    color: '#FFF',
    textAlign: 'right',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '14px',
  },
}));
